module.exports = __webpack_public_path__ + "img/1534492786.0f26ef16.jpg";